// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { SupportErrorContext } from '@/contexts/support-error-context';
import { useContext } from 'react';

export function useSupportError() {
  const context = useContext(SupportErrorContext);
  if (context === undefined) {
    throw new Error(
      'useSupportError must be used within a SupportErrorProvider'
    );
  }
  return context;
}
